import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { useNotificationStore } from '@/common';
import { axios } from '@/library/axios';
import { cookiesStorage } from '@/library/storage';
import type { VerifyOtpArgsType, VerifyOtpResponse } from '@/types/auth';
import { authConstants } from '@/utils/constants/auth';
import { getSecondsInADay } from '@/utils/functions';
import { displayError } from '@/utils/functions/displayError';

export const verifyOtp = async (
  data: VerifyOtpArgsType
): Promise<VerifyOtpResponse> => {
  const { otp, sessionId } = data.otpResponse;
  const { phone } = data;
  return axios.post(
    '/oauth/token',
    `username=${phone}&password={otp}${otp}:${sessionId}&grant_type=password&isUserConsentAccepted=true`,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
};

export const useVerifyOtp = () => {
  const { addNotification } = useNotificationStore();
  const mutation = useMutation({
    onSuccess: (data: any) => {
      addNotification({
        type: 'success',
        title: 'Success',
        message: 'OTP Verified Successfully',
      });
      cookiesStorage.setCookie(
        authConstants.OM_AUTH_USER_EXPIRY,
        data.data.expires_in,
        getSecondsInADay(data.data.expires_in)
      );
    },
    mutationFn: verifyOtp,
    useErrorBoundary: false,
  });

  useEffect(() => {
    displayError(mutation.error);
  }, [mutation.error]);

  return mutation;
};
